<template>
    <div>
        <h1 class="my-4">{{ $t('osce-schedule') }}</h1>

        <DynTable />
    </div>
</template>
<script>
import DynTable from 'src/components/Table/DynTable.vue';
export default {
	components: { 
        DynTable
    },
    data() {
        return {
            
        }
    },
    computed: { 

    },
    methods: {  

    }
};
</script>